import { Button, Card, CardHeader, CardTitle } from "alm-react-components";
import { useTranslation } from "react-i18next";
import { getCustmerProtal } from "../../../services/subscriptions";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/AppProvider";
import {
  ActionType,
  APPROUTES,
  DateFormat,
  SubscriptionStatus,
} from "../../../assets/constants/constants";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../common/loader/PageLoader";
import useSubscription from "../../../hooks/useSubscription";

 
export const BillingInvoice = () => {
  const { t } = useTranslation();
  const {state, dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const {callSubscription,subscriptionResponse} = useSubscription();
  const [scriptionDetail,setscriptionDetail]=useState<any>()
  useEffect(()=>{
    if (state.user) callSubscription();
  },[state.user])
  useEffect(() => {
    if (subscriptionResponse) {
      setLoading(false);
      setscriptionDetail(subscriptionResponse)
    }
  }, [subscriptionResponse]);
  // Monitor prop change to trigger loading state
  useEffect(() => {
    if (!scriptionDetail) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [scriptionDetail]);

  const onStripeHandle = async () => {
    if (
      scriptionDetail?.subscriptionStatus === SubscriptionStatus.trialOver ||
      scriptionDetail?.subscriptionStatus === SubscriptionStatus.trial
    ) {
      navigate(APPROUTES.selectCurrency);
    } else {
      dispatch({ type: ActionType.SET_LOADING, payload: true });
      await getCustmerProtal()
        .then((res: any) => {
          if (res.status === 200) {
            window.open(res?.data?.url, "_self");
          }
        })
        .catch((error: any) => {
          console.log(error);
        });
      dispatch({ type: ActionType.SET_LOADING, payload: false });
    }
  };

  return (
    <>
      {loading && <PageLoader />}
      <Card className=" dark: bg-fillDarkGrayCard900 dark:border-cardBorder my-7">
        <CardHeader className="p-7">
          <CardTitle className="flex items-center max-md:flex-col">
            <div
              className="pr-6 text-xl font-opensansBold font-bold mb-5 max-w-72 truncate"
              dangerouslySetInnerHTML={{
                __html: t("UserSettings.membershipPlan"),
              }}
            />

            {scriptionDetail?.subscriptionStatus && (
              <Button
                variant={"outline"}
                className="mb-5 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-8 py-2 bg-transparent"
                dangerouslySetInnerHTML={{
                  __html: `${t(
                    `MembershipPlan.${scriptionDetail?.subscriptionStatus}`
                  )}<span class="capitalize pl-2">${
                    scriptionDetail?.endDate
                      ? ` ( ${moment(scriptionDetail?.endDate).format(
                          DateFormat
                        )} )`
                      : ""
                  }</span>`,
                }}
              />
            )}
          </CardTitle>
          <p
            className="font-barlowRegular dark:text-white text-base"
            dangerouslySetInnerHTML={{
              __html: t("UserSettings.billingMsg"),
            }}
          />
        </CardHeader>
      </Card>
      <div className="flex items-center justify-between mb-16">
        <Button
          onClick={() => onStripeHandle()}
          className="text-base py-2 px-6 h-auto md:min-w-[217px]"
          dangerouslySetInnerHTML={{
            __html: `${
              scriptionDetail?.subscriptionStatus === SubscriptionStatus.active
                ? t("UserSettings.manage")
                : t("MembershipPlan.activate")
            }`,
          }}
        />
      </div>
    </>
  );
};
